<div class="upgrade-billing-container">
  <button mat-icon-button class="close-button" (click)="handleCancel()">
    <mat-icon>clear</mat-icon>
  </button>
  <app-billing-details [heading]="headingKey">
    <p description data-testid="plan-change-description">
      {{ descriptionKey | translate:{ btnText, endDate: (cardPlan.paymentModel.nextPaymentDate | date) } }}
    </p>

    <div *ngIf="previousPlanNameKey" plan-comparison class="plan-change-summary" data-testid="plan-change-summary">
      <div class="plan-change-side">
        <span class="plan-change-label">{{ 'billing.currentPlanLabel' | translate }}</span>
        <span class="plan-change-name">{{ previousPlanNameKey | translate }}</span>
        <span class="plan-change-price">{{ formatLocalizedPrice(previousPlanMonthlyPrice) }}/{{ 'common.user' | translate }}/{{ 'billing.shortMonth' | translate }}</span>
      </div>
      <mat-icon class="plan-change-arrow">arrow_forward</mat-icon>
      <div class="plan-change-side plan-change-side--new">
        <span class="plan-change-label">{{ 'billing.newPlanLabel' | translate }}</span>
        <span class="plan-change-name">{{ 'billing.' + cardPlan.name | translate }}</span>
        <span class="plan-change-price">{{ formatLocalizedPrice(cardPlan.paymentModel.priceMonthly) }}/{{ 'common.user' | translate }}/{{ 'billing.shortMonth' | translate }}</span>
      </div>
    </div>

    <app-actionable-item [label]="'billing.usersInCompany' | translate" [content]="cardPlan.usersCount.toString()"
      billing-detail-item></app-actionable-item>
    <!-- Minimum billable users -->
    <app-actionable-item *ngIf="cardPlan.paymentModel.minBillableQuantity > 1"
      [content]="cardPlan.paymentModel.minBillableQuantity.toString()" billing-detail-item>
      <div class="tooltip-container" label-info>
        <span>
          {{ 'billing.minBillableUsers' | translate }}
        </span>
        <app-info [tooltip]="'billing.minBillableUsersTooltip' | translate"></app-info>
      </div>
    </app-actionable-item>
    <app-actionable-item [label]="'billing.pricePerUserMonth' | translate" billing-detail-item>
      <span class="price-value" content>
        <span
          *ngIf="isYearlyBilling"
          class="price-value-original"
          data-testid="original-monthly-price"
        >{{ formatLocalizedPrice(cardPlan.paymentModel.priceMonthly) }}</span>
        <span data-testid="price-per-user">
          {{ formatLocalizedPrice(isYearlyBilling ? yearlyDiscountedMonthlyPrice : cardPlan.paymentModel.priceMonthly) }}
        </span>
      </span>
    </app-actionable-item>
    <app-actionable-item *ngIf="isYearlyBilling"
      [label]="'billing.disc' | translate" billing-detail-item
      data-testid="annual-discount-row">
      <span class="price-value" content>
        <span class="discount-badge" data-testid="annual-discount-badge">{{
          'billing.percentOff' | translate:{ value: annualDiscountPercent }
        }}</span>
        <span>-{{ formatLocalizedPrice(cardPlan.paymentModel.annualPayDiscount) }}</span>
      </span>
    </app-actionable-item>

    <!-- Discount -->
    <app-actionable-item *ngIf="cardPlan.paymentModel.discount" [label]="'billing.disc' | translate"
      billing-detail-item>
      <span class="price-value" content>
        {{ formatLocalizedPrice(cardPlan.paymentModel.discount.value * -1) }}
        ({{ cardPlan.paymentModel.discount.percentage }}% {{ 'billing.disc' | translate }})
      </span>
    </app-actionable-item>

    <app-actionable-item class="emphasized-row next-payment-amount-row" [label]="nextPaymentAmountLabelKey | translate" billing-detail-item
      data-testid="next-payment-amount-row">
      <span content class="next-payment-amount">
        <b>
          {{ formatLocalizedPrice(cardPlan.paymentModel.nextPaymentAmountCalculated) }}
          <mat-icon class="info-icon"
            *ngIf="cardPlan.paymentModel?.tax"
            [matTooltip]="'billing.nextPaymentTooltipForUpdate' | translate"
            matTooltipPosition="after"
            [matTooltipClass]="'custom-tooltip'">
            info_outline
          </mat-icon>
        </b>
        <em *ngIf="cardPlan.paymentModel.hasAddons" class="addon-fee-label">
          {{ 'billing.includeAddons' | translate }}
        </em>
      </span>
    </app-actionable-item>

    <p neutral-banner *ngIf="showYearlyDiscountLostBanner" data-testid="yearly-discount-lost-banner">
      {{ 'billing.yearlyDiscountLostBanner' | translate }}
    </p>

    <p savings-banner *ngIf="showYearlySavingsBanner" data-testid="yearly-savings-banner">
      {{ 'billing.yearlySavingsBanner' | translate:{ amount: formatLocalizedPrice(cardPlan.paymentModel.annualPayDiscount) } }}
    </p>

    <p minus-banner *ngIf="isDowngradeToBasic" data-testid="basic-plan-loss-banner">
      {{ 'billing.basicPlanLossBanner' | translate }}
    </p>
    <p chart-banner *ngIf="isUpgradeToStandard" data-testid="standard-plan-gain-banner">
      {{ 'billing.standardPlanGainBanner' | translate }}
    </p>

    <div footer-content class="footer-meta">
      <ng-container *ngIf="cardPlan.paymentModel.cardLast4; else addCard">
        <div class="footer-meta-row" data-testid="card-on-file">
          <mat-icon svgIcon="credit_card_neutral"></mat-icon>
          <span>{{ 'billing.cardOnFile' | translate:{ last4: cardPlan.paymentModel.cardLast4 } }}</span>
        </div>
      </ng-container>
      <ng-template #addCard>
        <app-add-credit-card-item [plan]="cardPlan"></app-add-credit-card-item>
      </ng-template>
      <div class="footer-meta-row" data-testid="next-payment-date">
        <mat-icon svgIcon="event_neutral"></mat-icon>
        <span>{{ 'billing.nextPaymentDate' | translate }}: {{ cardPlan.paymentModel.nextPaymentDate | date }}</span>
      </div>
      <div
        *ngIf="data.footerNoteHtml"
        class="footer-note"
        data-testid="discount-removal-note"
        [innerHTML]="data.footerNoteHtml"
      ></div>
    </div>
  </app-billing-details>
</div>

<div *ngIf="errorMsg" class="error-wrapper" data-testid="error-msg-block">
  <mat-icon>cancel</mat-icon>
  <span class="typography-caption">{{ errorMsg | translate }}</span>
</div>

<div class="btn-container">
  <button mat-stroked-button (click)="handleCancel()" class="cancel-button" aria-label="cancel button">
    {{ 'common.cancel' | translate | uppercase }}
  </button>
  <button mat-raised-button color="primary"
    (click)="handleSwitchPlan()" class="upgrade-plan-button"
    data-testid="confirm-plan-change-button">
    <ng-container *ngIf="!isLoadingAction; else loading">
      {{ (confirmButtonLabelKey ? (confirmButtonLabelKey | translate) : btnText) | uppercase }}
    </ng-container>
  </button>
</div>

<ng-template #loading>
  <mat-spinner class="btn-loader" diameter="24"></mat-spinner>
</ng-template>
